import classNames from 'clsx';
import interpolateComponents from 'interpolate-components';
import PropTypes from 'prop-types';
import { useContext } from 'react';
import PillButtonLink from 'src/common/components/shared/button/PillButtonLink';
import {
  RENEW_SUBSCRIPTION_BUTTON,
  SUBSCRIPTION_CAN_RENEW_COPY,
  SUBSCRIPTION_ENDED_COPY,
  SUBSCRIPTION_WILL_END_COPY,
} from 'src/common/constants/localizations/subscription';
import { RENEW_PATH } from 'src/common/constants/paths';
import { premiumSubscriptionStatus } from 'src/common/utils/subscription/subscriptionStatus';
import { LocationAndLocalizationContext } from '../../../../../providers/LocationAndLocalizationProvider';
import settingsCss from '../../../account-settings.module.scss';
import PaymentDetails from '../PaymentDetails';

export const Cancelled = ({ premiumStatus, termEndDate, renewProduct }) => {
  const { getLocalizedText } = useContext(LocationAndLocalizationContext);
  const subscriptionEndCopy =
    premiumStatus === premiumSubscriptionStatus.active
      ? getLocalizedText(SUBSCRIPTION_WILL_END_COPY)
      : getLocalizedText(SUBSCRIPTION_ENDED_COPY);

  return (
    <div data-testid="cancelledSubscriptionSettings">
      <div className={classNames('col-xs-12', 'col-sm-6', settingsCss.mediumSection)}>
        <PaymentDetails>
          <div className={settingsCss.section}>
            <span data-testid="subscriptionEndCopy">
              {termEndDate &&
                interpolateComponents({
                  mixedString: subscriptionEndCopy,
                  components: {
                    date: <span>{termEndDate}</span>,
                  },
                })}
            </span>
            {renewProduct && (
              <span data-testid="canRenewCopy">
                {interpolateComponents({
                  mixedString: ` ${getLocalizedText(SUBSCRIPTION_CAN_RENEW_COPY)}`,
                  components: {
                    price: <span data-testid="renewProductPrice">{renewProduct.price}</span>,
                  },
                })}
              </span>
            )}
          </div>
          <PillButtonLink
            className={settingsCss.renewSubscriptionButton}
            id="renewSubscriptionButton"
            dataTestId="renewSubscriptionButton"
            label={getLocalizedText(RENEW_SUBSCRIPTION_BUTTON)}
            to={RENEW_PATH}
          />
        </PaymentDetails>
      </div>
    </div>
  );
};

Cancelled.propTypes = {
  premiumStatus: PropTypes.string.isRequired,
  termEndDate: PropTypes.string.isRequired,
  renewProduct: PropTypes.object,
};

export default Cancelled;
